import React from 'react';
import { FaRegComments } from 'react-icons/fa';
import { CgArrowLongRight } from 'react-icons/cg';
import { Link } from 'react-router-dom';

const BlogSingleItem = ({ image, user_image, name, title, video_icon , content, month, day, year, id}) => {
   return (
      <>
         <div className="blog__item-2 mb-50 fix" >
            <div className={`blog__thumb-2 w-img fix ${video_icon && 'p-relative'}`}>
               <Link to={`/BlogDetails/${id}`}>
                  <img src={image} alt="" />
               </Link>
               {video_icon && video_icon}
            </div>
            <div className="blog__content-2">
               <div className="blog__meta-2 mb-15 sm:tw-flex tw-items-center">
                  <div className="blog__user pr-20 mr-20">
                     <Link to={`/BlogDetails/${id}`}>
                        <img src={`assets/img/blog/user/user_${user_image}.svg`} alt="" />
                        <span className="blog__user-name">{name}</span>
                     </Link>
                  </div>
                  <div className="blog__date">
                     <span>{day} {month} {year}</span>
                  </div>
               </div>
               <h2>
                  <Link to={`/BlogDetails/${id}`}>{title}</Link>
               </h2>
               <p>{content}</p>
               <div className="blog__btn sm:tw-flex tw-justify-between">
                  <div className="blog__btn">
                     <Link to={`/BlogDetails/${id}`} className="link-btn-2" aria-label={`Read more: ${title}`}>
                        Read More
                        <i > <CgArrowLongRight /> </i>
                        <i > <CgArrowLongRight /> </i>
                     </Link>
                  </div>
                  <div className="blog__comment">
                     <Link to={`/BlogDetails/${id}`}>
                        <i><FaRegComments /></i>
                        Comments
                     </Link>
                  </div>
               </div>
            </div>
         </div>
      </>
   );
};

export default BlogSingleItem;